"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_helmet_1 = require("react-helmet");
const react_redux_1 = require("react-redux");
const immutable_1 = require("immutable");
const mui_1 = require("tss-react/mui");
const react_use_1 = require("react-use");
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const CssBaseline_1 = __importDefault(require("@mui/material/CssBaseline"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const core_1 = require("companion-app-components/utils/core");
const auth_1 = require("companion-app-components/flux/auth");
const profile_1 = require("companion-app-components/flux/profile");
const datasets_1 = require("companion-app-components/flux/datasets");
const datasetSharesSelectors_1 = require("companion-app-components/flux/dataset-shares/datasetSharesSelectors");
const root_ui_1 = require("companion-app-components/flux/root-ui");
const subscriptionsSelectors_1 = require("data/subscriptions/subscriptionsSelectors");
const ssoActions_1 = require("data/sso/ssoActions");
const EmptyDialog_1 = require("components/Dialogs/EmptyDialog");
const QButton_1 = __importDefault(require("components/QButton"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const types_1 = require("components/Dialogs/NotificationDialog/types");
const utils_1 = require("containers/App/Header/ProfileMenu/utils");
const confused_star_svg_1 = __importDefault(require("assets/confused-star.svg"));
const TableMyDatasets_1 = __importDefault(require("./TableMyDatasets"));
const styles_1 = __importDefault(require("./styles"));
const TableSharedDatasets_1 = __importDefault(require("./TableSharedDatasets"));
const SubscriptionAlert_1 = __importDefault(require("./SubscriptionAlert"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const ProfilePage = () => {
    const [hoveredMyDataset, setHoveredMyDataset] = (0, react_1.useState)();
    const [hoveredSharedDataset, setHoveredSharedDataset] = (0, react_1.useState)();
    const { classes, theme } = useStyles();
    const dispatch = (0, react_redux_1.useDispatch)();
    const authLogout = (payload, meta) => dispatch(auth_1.authActions.authLogout(payload, meta));
    const dispatchRemoveDialog = (dialogId) => dispatch(root_ui_1.rootUiActions.removeDialog(dialogId));
    const dispatchGetSSOTokenAction = (data, meta) => dispatch((0, ssoActions_1.getSSOToken)(data, meta));
    const authSelectDataset = (dataset) => dispatch(auth_1.authActions.authSelectDataset(dataset));
    const createActionDialog = (uiRootData) => dispatch(root_ui_1.rootUiActions.createDialog(uiRootData));
    const profile = (0, react_redux_1.useSelector)((state) => profile_1.profileSelectors.getProfile(state));
    const datasetId = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getDatasetId(state));
    const authSession = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getAuthSession(state));
    const datasets = (0, react_redux_1.useSelector)((state) => datasets_1.datasetsSelectors.getActiveDatasets(state));
    const subscription = (0, react_redux_1.useSelector)((state) => (0, subscriptionsSelectors_1.getActiveSubscription)(state));
    const datasetsSharing = (0, react_redux_1.useSelector)(datasetSharesSelectors_1.getDatasetSharesById);
    (0, react_use_1.useEffectOnce)(() => {
        core_1.tracker.track(core_1.tracker.events.profilePageView);
    });
    const fullName = (0, utils_1.getFullName)(profile);
    const currentDataset = datasets.get(datasetId);
    const ownDatasets = datasets.filter((objDataset) => !objDataset.shared);
    const sharedDatasets = datasets.filter((objDataset) => objDataset.shared);
    const logoutClick = () => authLogout({ reason: 'AUTH_LOGOUT_USER_INITIATED' }, { context: 'profile' });
    const goToCommunity = () => {
        dispatchRemoveDialog('community-verify-email');
        // eslint-disable-next-line no-promise-executor-return
        new Promise((resolve, reject) => {
            var _a, _b;
            return dispatchGetSSOTokenAction(undefined, {
                resolve,
                reject,
                axiosConfig: {
                    params: {
                        clientId: (_a = (0, core_1.getBuildConfig)()) === null || _a === void 0 ? void 0 : _a.sso_client_id,
                        redirect_uri: (_b = (0, core_1.getBuildConfig)()) === null || _b === void 0 ? void 0 : _b.community_url,
                    },
                },
            });
        })
            .then((response) => {
            var _a, _b, _c;
            if (((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b[0].code) === 'QCS-0401-7') {
                root_ui_1.rootUiActions.createDialog(root_ui_1.rootUiTypes.mkRootUiData({
                    id: 'community-verify-email',
                    type: EmptyDialog_1.DIALOG_TYPE_EMPTY_DIALOG,
                    allowNesting: true,
                    props: (0, immutable_1.Map)({
                        colorBar: theme.palette.background.default,
                        content: (<ZeroStateView_1.default icon={confused_star_svg_1.default} primary="Verify your email address" secondary="We sent you an email to confirm your identity. Once verified, click here to try again.">
                  <QButton_1.default variant="contained" onClick={goToCommunity}>
                    Go to community
                  </QButton_1.default>
                </ZeroStateView_1.default>),
                    }),
                }));
            }
            else if (assert((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.redirectUri, 'no sso redirectUri')) {
                // setTimeout protects from popup blocker
                setTimeout(() => window.open(response.data.redirectUri, '_blank'), 1000);
            }
        })
            .catch((error) => assert(false, error));
    };
    const myAccountClick = () => {
        var _a;
        const myAccountUrl = (_a = (0, core_1.getEnvironmentConfig)()) === null || _a === void 0 ? void 0 : _a.myaccount_url;
        if (myAccountUrl) {
            core_1.tracker.track(core_1.tracker.events.myAccount, { location: 'profile page' });
            window.open(`${myAccountUrl}?bearer=${authSession.accessToken}`);
        }
    };
    const handleDatasetClick = (dataset) => {
        if (datasetId !== dataset.id) {
            core_1.tracker.track(core_1.tracker.events.datasetChange, { location: 'profile page' });
            setTimeout(() => authSelectDataset(auth_1.authTypes.AuthSelectDatasetPayload({ dataset })), 100);
            createActionDialog(root_ui_1.rootUiTypes.mkRootUiData({
                type: types_1.DIALOG_TYPE,
                allowNesting: false,
                props: (0, immutable_1.Map)((0, types_1.mkNotificationDialogProps)({
                    buttonLabel: null,
                    content: (<div className={classes.datasetSwitchingContent}>
              <Typography_1.default variant="body1">
                Switching to {dataset.name}
              </Typography_1.default>
              <CircularProgress_1.default className={classes.datasetSwitchingProgress} size={50}/>
            </div>),
                    dialogProps: {
                        disableBackdropClick: true,
                        disableEscapeKeyDown: true,
                    },
                    title: '',
                })),
            }));
        }
    };
    return (<Box_1.default height="100%">
      <react_helmet_1.Helmet>
        <title>Profile</title>
        <meta name="profile" content="Profile Page"/>
      </react_helmet_1.Helmet>
      <CssBaseline_1.default />
      <AppBar_1.default position="sticky" elevation={0} className={classes.header} sx={{ mb: 2 }}>
        <Toolbar_1.default className={classes.headerContent}>
          <Box_1.default flexGrow={1} display="flex" justifyContent="space-between">
            <Stack_1.default>
              <Stack_1.default direction="row" alignItems="center" spacing={1}>
                {fullName && (<Typography_1.default component="span" color="text.secondary" fontSize={20} fontWeight={500}>
                    {fullName}
                  </Typography_1.default>)}
                {fullName && profile && (profile === null || profile === void 0 ? void 0 : profile.username) && (<Typography_1.default variant="body1" component="span" color="koalaGrey">
                    |
                  </Typography_1.default>)}
                {profile && (profile === null || profile === void 0 ? void 0 : profile.username) && (<Typography_1.default variant="body1" component="span" color="koalaGrey">
                    {profile.username}
                  </Typography_1.default>)}
              </Stack_1.default>
              {subscription && (subscription === null || subscription === void 0 ? void 0 : subscription.tierName) && (<Typography_1.default variant="body1" component="div" color="text.secondary">
                  {subscription.tierName}
                </Typography_1.default>)}
            </Stack_1.default>
            <Stack_1.default direction="row" spacing={1}>
              <Button_1.default id="my-account-button" onClick={myAccountClick} className={classes.headerControls}>
                My Account
              </Button_1.default>
              <Button_1.default onClick={goToCommunity} className={classes.headerControls}>
                Community
              </Button_1.default>
              <Button_1.default id="my-account-sign-out" onClick={logoutClick} className={classes.headerControls}>
                Sign Out
              </Button_1.default>
            </Stack_1.default>
          </Box_1.default>
        </Toolbar_1.default>
      </AppBar_1.default>
      <Stack_1.default p={3}>
        {ownDatasets && (ownDatasets === null || ownDatasets === void 0 ? void 0 : ownDatasets.size) > 0 && (<>
            <Typography_1.default color="text.secondary" fontSize={20} mb={1}>
              My Cloud Accounts
            </Typography_1.default>
            <Paper_1.default className={classes.paperContainer}>
              {subscription !== null && !subscription.active && <SubscriptionAlert_1.default label="Your subscription has expired. To restore access to your Cloud Accounts, log in to the Quicken website and renew or activate your subscription."/>}
              <div className={!subscription.active && classes.disableSection}>
                <TableMyDatasets_1.default datasets={ownDatasets} currentDataset={currentDataset} datasetsSharing={datasetsSharing} hoveredDataset={hoveredMyDataset} setHoveredDataset={setHoveredMyDataset} onDatasetClick={handleDatasetClick}/>
              </div>
            </Paper_1.default>
          </>)}
        {sharedDatasets && (sharedDatasets === null || sharedDatasets === void 0 ? void 0 : sharedDatasets.size) > 0 && (<>
            <Typography_1.default color="text.secondary" fontSize={20} mb={1}>
              Shared with me
            </Typography_1.default>
            <Paper_1.default className={classes.paperContainer}>
              <TableSharedDatasets_1.default datasets={sharedDatasets} currentDataset={currentDataset} hoveredDataset={hoveredSharedDataset} setHoveredDataset={setHoveredSharedDataset} handleLogout={logoutClick} datasetsSharing={datasetsSharing} onDatasetClick={handleDatasetClick}/>
            </Paper_1.default>
          </>)}
      </Stack_1.default>
    </Box_1.default>);
};
exports.default = ProfilePage;
